import {MarkerService} from '@/utils/gmaps/gmaps.marker.service';
import './expandable.marker.css';
import MoveCameraOperation = DisguiseDto.MoveCameraOperation;

class ExpandableMarker implements MarkerService<DisguiseDto.ExpandableGmapsMarkerContent> {


    private static toggleHighlight(markerView: google.maps.marker.AdvancedMarkerElement, markerConfig: DisguiseDto.GMapsMarker) {
        if (markerView.content instanceof HTMLElement) {
            if (!markerView.content.classList.contains('expandable-marker-item--highlight')) {
                ExpandableMarker.addHighlight(markerView, markerConfig);
                return true;
            } else {
                ExpandableMarker.removeHighlight(markerView, markerConfig);
                return false;
            }
        }
        return null;
    }

    private static addHighlight(markerView: google.maps.marker.AdvancedMarkerElement, markerConfig: DisguiseDto.GMapsMarker) {
        if (markerView.content instanceof HTMLElement) {
            if (!markerView.content.classList.contains('expandable-marker-item--highlight')) { // prevent adding twice
                markerView.content.classList.add('expandable-marker-item--highlight');
                markerView.zIndex = (((markerConfig.content as DisguiseDto.ExpandableGmapsMarkerContent) || {}).zindexOnExpand) || 1;
            }
        }
    }

    private static removeHighlight(currentMarker: google.maps.marker.AdvancedMarkerElement, markerConfig: DisguiseDto.GMapsMarker) {
        if (currentMarker.content instanceof HTMLElement) {
            currentMarker.content.classList.remove('expandable-marker-item--highlight');
            currentMarker.zIndex = null;
        }
    }

    private static triggerOperations(
      operations: DisguiseDto.IGMapsOperationUnion[],
      gmapsView: google.maps.Map
    ) {
        for (const currentOperation of operations || []) {
            switch (currentOperation['@type']) {
                case 'MoveCamera': {
                    const castedOperation = currentOperation as MoveCameraOperation;
                    if (castedOperation.center && castedOperation.center.lat !== undefined && castedOperation.center.lng !== undefined) {
                        gmapsView.moveCamera({
                            center: {
                                lat: castedOperation.center.lat,
                                lng: castedOperation.center.lng
                            },
                            zoom: castedOperation.zoom,
                        });
                    }
                    break;
                }
            }
        }
    }

    generateMarkerContent(config: DisguiseDto.ExpandableGmapsMarkerContent): Node | null {
        const result = document.createElement('div');
        result.classList.add('expandable-marker-item');
        result.innerHTML = `
            <div class="expandable-marker-item__shortinfo">${config.shortInfo}</div>
            <div class="expandable-marker-item__longinfo">${config.longInfo}</div>
        `;

        return result;
    }

    onClick(
      markerConfig: DisguiseDto.GMapsMarker,
      marker: google.maps.marker.AdvancedMarkerElement,
      allMarkers: google.maps.marker.AdvancedMarkerElement[],
      gmapsView: google.maps.Map
    ) {
        const contentConfig = (markerConfig.content || {}) as DisguiseDto.ExpandableGmapsMarkerContent;
        if (contentConfig.collapseOthersOnExpand) {
            for (const currentMarker of allMarkers) {
                if (currentMarker !== marker) {
                    ExpandableMarker.removeHighlight(currentMarker, markerConfig);
                }
            }
        }
        if (ExpandableMarker.toggleHighlight(marker, markerConfig)) {
            if (contentConfig.operationsOnExpand) {
                ExpandableMarker.triggerOperations(contentConfig.operationsOnExpand, gmapsView);
            }
        } else {
            if (contentConfig.operationsOnCollapse) {
                ExpandableMarker.triggerOperations(contentConfig.operationsOnCollapse, gmapsView);
            }
        }
    }

    onUserRequestedDetails(
      markerConfig: DisguiseDto.GMapsMarker,
      marker: google.maps.marker.AdvancedMarkerElement,
      allMarkers: google.maps.marker.AdvancedMarkerElement[],
      gmapsView: google.maps.Map
    ) {
        for (const currentMarker of allMarkers) {
            if (currentMarker !== marker) {
                ExpandableMarker.removeHighlight(currentMarker, markerConfig);
            }
        }
        ExpandableMarker.addHighlight(marker, markerConfig);
        if (marker.position && typeof marker.position.lat === 'number' && typeof marker.position.lng === 'number') {
            gmapsView.moveCamera({
                center: {
                    lat: marker.position.lat,
                    lng: marker.position.lng,
                },
                zoom: 20,
            });
        }
    }
}

export {ExpandableMarker};
